export default "__VITE_ASSET__CtEvWcAv__"